import { BaseModule } from './BaseModule';
import PopRecordModule from './PopRecord';
import { ModuleBaseOption } from '../interfaces/module';

class OnLeadSelected extends BaseModule<ModuleBaseOption> {
    public start(): void {
        if (this.getIsInit()) {
            this.listenFromRCX();
        }
    }
    private listenFromRCX() {
        this.mRCXAdapter!.onLeadSelected((data: any) => {
            this.onLeadSelected(data);
        });
    }

    public async onLeadSelected(data: any) {
        const phoneNumber = data.ani || data?.aniE164;
        const response = await this.mServiceNowAdapter!.getStandMatch(phoneNumber, 'phone');

        PopRecordModule.onMatchRecords(response, data);
    }
}

export default new OnLeadSelected();
